import {
    headers,
    agentEntrySaveUrl,
    AGENT_ENTRY_SAVE_ACTION_TYPE,
    agentEntryUpdateUrl,
    AGENT_ENTRY_UPDATE_ACTION_TYPE,
    getAgentListUrl,
    AGENT_LIST_ACTION_TYPE,
    getAgentDetailsUrl,
    GET_AGENT_DETAILS_ACTION_TYPE,
    verifyAgentEmailUrl,
    VERIFY_AGENT_EMAIL_ACTION_TYPE
} from "../../../utils/constants"
import { axiosPost, axiosGet } from "../../../react_axios/Axios"



export const agentEntrySave_action = (isSelfPaid, companyName, add1, add2, city, state, pin, countryId, prefixPersonInchFirst, personInchFirst,
    personInchLast, designation, mobNo, altMobNo, telephone, altTelephone, primaryEmail, secondaryEmail, website,
    isSameAsCorrespondence, billCompanyName, billAdd1, billAdd2, billCity, billState, billPin, billCountryId, billPrefixPersonInchFirst,
    billPersonInchFirst, billPersonInchLast, billDesignation, billMobNo, billAltMobNo, billTelephone, billAltTelephone,
    billPrimaryEmail, billSecondaryEmail, billWebsite, accName, accNo, accType, bankName, branchName, IFSC, finalAgentCode, nationalityId,
    totalNationalArea, totalInternationalArea, areaAllocationCountryData, areaAllocationChapterData) => async (dispatch) => {
        try {
            const mapdata = {
                Userid: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
                AccountID: null,
                ExhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
                IsSelfPaid: isSelfPaid,
                CompanyName: companyName,
                Address1: add1,
                Address2: add2,
                City: city,
                State: state,
                Pin: pin,
                CountryID: parseInt(countryId),
                Title_PersonIncharge: prefixPersonInchFirst,
                PersonIncharge: personInchFirst,
                LastNamePersonIncharge: personInchLast,
                Designation: designation,
                MobileNo: `${sessionStorage.getItem('sessionPreMobNo')}-${mobNo}`,
                AlternateMobileNo: `${sessionStorage.getItem('sessionPreAltMobNo')}-${altMobNo}`,
                Telephone: `${sessionStorage.getItem('sessionPreTelNo')}-${telephone}`,
                Telephone1: `${sessionStorage.getItem('sessionPreAltTelNo')}-${altTelephone}`,
                PrimaryEmail: primaryEmail,
                SecondaryEmail: secondaryEmail,
                Website: website,
                SameAsCorrespondence: isSameAsCorrespondence,
                InvCompanyName: billCompanyName,
                InvAddress1: billAdd1,
                InvAddress2: billAdd2,
                InvCity: billCity,
                InvState: billState,
                InvPin: billPin,
                InvCountryID: billCountryId,
                Title_InvPersonIncharge: billPrefixPersonInchFirst,
                InvPersonIncharge: billPersonInchFirst,
                InvLastNamePersonIncharge: billPersonInchLast,
                InvDesignation: billDesignation,
                InvMobileNo: `${sessionStorage.getItem('sessionInvPreMobNo')}-${billMobNo}`,
                InvAlternateMobileNo: `${sessionStorage.getItem('sessionInvPreAltMobNo')}-${billAltMobNo}`,
                InvTelephone: `${sessionStorage.getItem('sessionInvPreTelNo')}-${billTelephone}`,
                InvTelephone1: `${sessionStorage.getItem('sessionInvPreAltTelNo')}-${billAltTelephone}`,
                InvPrimaryEmail: billPrimaryEmail,
                InvSecondaryEmail: billSecondaryEmail,
                InvWebsite: billWebsite,
                AccountName: accName,
                AccountNo: accNo,
                AccountType: accType,
                BankName: bankName,
                BranchName: branchName,
                SwiftCode_IFSCCode: IFSC,
                AgentCode: finalAgentCode,
                AgentRegistrationType: nationalityId,
                DomesticArea: parseFloat(totalNationalArea),
                InternationalArea: parseFloat(totalInternationalArea),
                countryList: areaAllocationCountryData,
                chapterList: areaAllocationChapterData
            }
            console.log("agentEntrySave_action-Action--------------------------->", mapdata)
            const res = await axiosPost(agentEntrySaveUrl, mapdata, headers);

            dispatch({
                type: AGENT_ENTRY_SAVE_ACTION_TYPE,
                payload: res,
            })
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    }

export const agentEntryUpate_action = (AccountId, isSelfPaid, companyName, add1, add2, city, state, pin, countryId, prefixPersonInchFirst, personInchFirst,
    personInchLast, designation, mobNo, altMobNo, telephone, altTelephone, primaryEmail, secondaryEmail, website,
    isSameAsCorrespondence, billCompanyName, billAdd1, billAdd2, billCity, billState, billPin, billCountryId, billPrefixPersonInchFirst,
    billPersonInchFirst, billPersonInchLast, billDesignation, billMobNo, billAltMobNo, billTelephone, billAltTelephone,
    billPrimaryEmail, billSecondaryEmail, billWebsite, accName, accNo, accType, bankName, branchName, IFSC, finalAgentCode, nationalityId,
    totalNationalArea, totalInternationalArea, areaAllocationId, areaAllocationCountryData, areaAllocationChapterData) => async (dispatch) => {
        try {
            const mapData = {
                Userid: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
                AccountID: AccountId,
                ExhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
                IsSelfPaid: isSelfPaid,
                CompanyName: companyName,
                Address1: add1,
                Address2: add2,
                City: city,
                State: state,
                Pin: pin,
                CountryID: countryId,
                Title_PersonIncharge: prefixPersonInchFirst,
                PersonIncharge: personInchFirst,
                LastNamePersonIncharge: personInchLast,
                Designation: designation,
                MobileNo: `${sessionStorage.getItem('sessionPreMobNo')}-${mobNo}`,
                AlternateMobileNo: `${sessionStorage.getItem('sessionPreAltMobNo')}-${altMobNo}`,
                Telephone: `${sessionStorage.getItem('sessionPreTelNo')}-${telephone}`,
                Telephone1: `${sessionStorage.getItem('sessionPreAltTelNo')}-${altTelephone}`,
                PrimaryEmail: primaryEmail,
                SecondaryEmail: secondaryEmail,
                Website: website,
                SameAsCorrespondence: isSameAsCorrespondence,
                InvCompanyName: billCompanyName,
                InvAddress1: billAdd1,
                InvAddress2: billAdd2,
                InvCity: billCity,
                InvState: billState,
                InvPin: billPin,
                InvCountryID: billCountryId,
                Title_InvPersonIncharge: billPrefixPersonInchFirst,
                InvPersonIncharge: billPersonInchFirst,
                InvLastNamePersonIncharge: billPersonInchLast,
                InvDesignation: billDesignation,
                InvMobileNo: `${sessionStorage.getItem('sessionInvPreMobNo')}-${billMobNo}`,
                InvAlternateMobileNo: `${sessionStorage.getItem('sessionInvPreAltMobNo')}-${billAltMobNo}`,
                InvTelephone: `${sessionStorage.getItem('sessionInvPreTelNo')}-${billTelephone}`,
                InvTelephone1: `${sessionStorage.getItem('sessionInvPreAltTelNo')}-${billAltTelephone}`,
                InvPrimaryEmail: billPrimaryEmail,
                InvSecondaryEmail: billSecondaryEmail,
                InvWebsite: billWebsite,
                AccountName: accName,
                AccountNo: accNo,
                AccountType: accType,
                BankName: bankName,
                BranchName: branchName,
                SwiftCode_IFSCCode: IFSC,
                AgentCode: finalAgentCode,
                AgentRegistrationType: nationalityId,
                DomesticArea: totalNationalArea,
                InternationalArea: totalInternationalArea,
                AgentAreaAllocationID: areaAllocationId,
                countryList: areaAllocationCountryData,
                chapterList: areaAllocationChapterData
            }
            console.log("receiptUpdate_action-Action Update--------------------------->", mapData);
            const res = await axiosPost(agentEntryUpdateUrl, mapData, headers);
            dispatch({
                type: AGENT_ENTRY_UPDATE_ACTION_TYPE,
                payload: res
            })
            return Promise.resolve(res)
        } catch (error) {
            return Promise.resolve(error)
        }
    }

export const getAgentList_action = () => async (dispatch) => {

    try {
        const params = {
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID
        }
        console.log("getAgentList_action -Action--------------------------->", params)

        const res = await axiosGet(getAgentListUrl, params, headers);
        dispatch({
            type: AGENT_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const agentDetails_action = (accId) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: accId,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID')
        }
        console.log("agentDetails_action-Action--------------------------->", params)

        const res = await axiosGet(getAgentDetailsUrl, params, headers);
        dispatch({
            type: GET_AGENT_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const verifyAgentEmail_action = (email, code) => async (dispatch) => {
    try {
        const param = {
            EmailID: email,
            AgentCode: code,
        }

        const res = await axiosGet(verifyAgentEmailUrl, param, headers);
        dispatch({
            type: VERIFY_AGENT_EMAIL_ACTION_TYPE,
            payload: res,
        });
        console.log("verifyAgentEmail_action--------->", param)
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

